module.exports = __webpack_public_path__ + "img/IQ.e6713875.png";